export interface IUrlInfo {
  linkId?: string | null;
}

const extractUrlInfo = (params: URLSearchParams): IUrlInfo => {
  const linkId = params.get('linkid');

  return {
    linkId,
  };
};

export default extractUrlInfo;
